import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { ActiveLanguagesCollection } from './active-languages.types';

export function activeLanguagesBackend(): Backend<ActiveLanguagesCollection> {
  return {
    defaultOrder: {
      field: 'code',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'language/getActiveLanguages.php',
      isGaf: true,
      params: {
        language_codes: ids || getQueryParamValue(query, 'code'),
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
